import React, { useEffect, useState, useRef } from "react";

const ConfirmationCode = ({ onChange, size = 6, hasError }) => {
  const itemsRef = useRef([]);
  const [value, setValue] = useState(new Map());

  // onChange to split and set the value
  // Focus the next input
  const codeChangeHandler = (event) => {
    const isValid = handleTestValue(event);
    const [, codeFieldIndex] = event.target.name.split("-");
    let fieldIntIndex = parseInt(codeFieldIndex, 10);
    if (isValid) {
      const keyCode = event.keyCode || event.which;
      // If not Backspace, delete or tab
      if (keyCode !== 8 && keyCode !== 46 && keyCode !== 9) {
        setValue(value.set(fieldIntIndex, event.key));
        onChange(value);
        itemsRef.current[fieldIntIndex].value = event.key;
        if (fieldIntIndex < size - 1) {
          itemsRef.current[fieldIntIndex + 1].focus();
        } else {
          const field = document.querySelector(
            `Input[name=code-${fieldIntIndex}]`
          );
          field.blur();
        }
      }
    } else {
      itemsRef.current[fieldIntIndex].value = !!value.get(fieldIntIndex)
        ? value.get(fieldIntIndex)
        : "";
    }
  };

  // Focus after mounting the component
  useEffect(() => {
    if (itemsRef.current && itemsRef.current[0]) {
      itemsRef.current[0].focus();
    }
  }, [itemsRef]);

  useEffect(() => {
    const handlePasteAnywhere = (event) => {
      const regex = /[0-9]+|\./;
      if (!regex.test(Number(event.clipboardData.getData("text")))) {
        event.preventDefault();
      } else {
        event.clipboardData
          .getData("text")
          .trim()
          .split("")
          .forEach((element, index) => {
            setValue(value.set(index, element));
            itemsRef.current[index].value = element;
            if (index < size - 1) {
              itemsRef.current[index + 1].focus();
            } else {
              const field = document.querySelector(`Input[name=code-${index}]`);
              field.blur();
            }
          });
        onChange(value);
      }
    };

    window.addEventListener("paste", handlePasteAnywhere);

    return () => {
      window.removeEventListener("paste", handlePasteAnywhere);
    };
  }, []);

  const handleTestValue = (evt) => {
    var theEvent = evt || window.event;
    var keyCode = theEvent.keyCode || theEvent.which;

    // Accept: 0-9, Backspace, Delete, Tab
    if (
      (keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      keyCode === 8 ||
      keyCode === 9 ||
      keyCode === 46
    ) {
      return true;
    } else {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
      return false;
    }
  };

  const codeInputFields = new Array(size).fill(0).map((item, index) => (
    <input
      type="number"
      className={`w-full aspect-square border border-gray-300 rounded-md shadow-sm text-center text-4xl font-bold appearance-none remove-number-style ${
        hasError && "text-red-900"
      }`}
      style={{
        color: !hasError && "#2C3F58",
        ...(hasError && { border: "1px solid #FF443A" }),
      }}
      ref={(ref) => itemsRef.current.push(ref)}
      name={`code-${index}`}
      key={index}
      onKeyUp={(e) => {
        codeChangeHandler(e);
      }}
      onPaste={(e) => {
        codeChangeHandler(e);
      }}
      maxLength={1}
    />
  ));

  return (
    <div className="min-h-[94px]">
      <div className="flex flex-row items-center justify-between gap-2">
        {codeInputFields}
      </div>
      {hasError && (
        <span className="text-red-500 text-sm block mt-1">{hasError}</span>
      )}
    </div>
  );
};

export default ConfirmationCode;
